import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		redirect: { name: "UserMain" },
	},
	{
		path: "/app",
		component: () => import("../views/User.vue"),
		children: [
			{
				path: "",
				name: "UserMain",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/Main.vue"
						),
				},
			},
			{
				path: "login",
				name: "UserLogin",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/Login.vue"
						),
				},
			},
			{
				path: "register",
				name: "UserRegister",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/Register.vue"
						),
				},
			},
			{
				path: "profile",
				name: "UserProfile",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/Profile.vue"
						),
				},
			},
			{
				path: "race-details",
				name: "RaceDetails",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/RaceDetails.vue"
						),
				},
			},
			{
				path: "circuit-details",
				name: "CircuitDetails",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/CircuitDetails.vue"
						),
				},
			},
			{
				path: "my-races",
				name: "MyRaces",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/MyRaces"
						),
				},
			},
			{
				path: "confirm-payment",
				name: "ConfirmRacePayment",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/Payment"
						),
				},
			},
			{
				path: "reset-password/:token",
				name: "ResetPassword",
				components: {
					default: () =>
						import(
							/* webpackChunkName: "app" */
							"../views/user/ResetPassword"
						),
				},
			},
		],
	},
	{
		path: "/aviso-legal",
		name: "AvisoLegal",
		component: () =>
			import(
				/* webpackChunkName: "legal" */
				/* webpackPreFetch: true */

				"../views/user/AvisoLegal.vue"
			),
	},
	{
		path: "/politica-privacidad",
		name: "PoliticaPrivacidad",
		component: () =>
			import(
				/* webpackChunkName: "legal" */
				/* webpackPreFetch: true */
				"../views/user/PoliticaPrivacidad.vue"
			),
	},
	{
		path: "/admin",
		component: () =>
			import(
				/* webpackChunkName: "admin" */
				/* webpackPreFetch: true */
				"../views/Admin.vue"
			),
		children: [
			{
				path: "",
				redirect: { name: "AdminStats" },
			},
			{
				//Login view
				path: "login",
				name: "AdminLogin",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */
						"../views/admin/Login.vue"
					),
			},
			{
				path: "stats",
				name: "AdminStats",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/Stats.vue"
					),
			},
			{
				//Main admin view
				path: "race-list",
				name: "AdminRaceList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/RaceList.vue"
					),
			},
			{
				//Main admin view
				path: "circuit-list",
				name: "AdminCircuitList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/CircuitList.vue"
					),
			},
			{
				//Main admin view
				path: "user-list",
				name: "AdminUserList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/UserList.vue"
					),
			},
			{
				//Main admin view
				path: "tag-list",
				name: "AdminTagList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/TagList.vue"
					),
			},
			{
				//Main admin view
				path: "results-list",
				name: "AdminResultsList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/ResultsList.vue"
					),
			},
			{
				//Main admin view
				path: "payment-list",
				name: "AdminPaymentList",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/PaymentList.vue"
					),
			},
			{
				//View to create a new race
				path: "create-race",
				name: "AdminCreateRace",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/CreateRace.vue"
					),
			},
			{
				//View to create a new race
				path: "create-circuit",
				name: "AdminCreateCircuit",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/CreateCircuit.vue"
					),
			},
			{
				//View to create a new race
				path: "race-inscriptions",
				name: "RaceInscriptions",
				component: () =>
					import(
						/* webpackChunkName: "admin" */
						/* webpackPreFetch: true */ "../views/admin/RaceUserList.vue"
					),
				props: true,
			},
		],
	},
	{
		path: "/map-capture/:id",
		name: "AdminMapCapture",
		component: () =>
			import(
				/* webpackChunkName: "admin" */
				/* webpackPreFetch: true */ "../views/admin/MapCapture.vue"
			),
		props: true,
	},
	{
		path: "*",
		redirect: "/",
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
